<template>
    <div>
        <div ref="photo" v-if="isPhotos" class="photos">
            <div class="photos__row">
                <div v-for="item in data" :key="item.Id" class="photos__item">
                    <a :href="`${path}/${item.File}`" class="photos__photo fancybox" data-fancybox="gallery">
                        <div class="photos__overlay"></div>
                        <div class="photos__img cover" :style="{ backgroundImage: `url('${path}/thumb/${item.Thumb}')` }"></div>
                    </a>
                </div>
            </div>
            <div class="photos__bottom">
                <div class="wbutton d-inline-flex align-items-center" @click="fetch">
                    <span v-if="isFetching" class="spinner-grow spinner-grow-sm mr-2" role="status" aria-hidden="true"></span>
                    {{ isFetching ? 'wczytuję' : 'zobacz więcej' }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
export default {
    name: "Gallery",
    props: {
        id: {
            type: Number,
            required: true,
            default: 0
        },
        storage: {
            type: String,
            required: true,
            default: 'subpagesphoto'
        },
        path: {
            type: String,
            required: true,
            default: '/file/subpages/gallery'
        }
    },
    data() {
        return {
            data: [],
            loaded: 0,
            isFetching: false
        }
    },
    computed: {
        isPhotos() {
            return this.data.length > 0;
        }
    },
    methods: {
        async fetch() {
            if (!this.isFetching) {
                this.isFetching = true;
                try {
                    let { data } = await this.$http.post('/load-pictures', {
                        id: this.id,
                        loaded: this.loaded,
                        storage: this.storage
                    });
                    this.data.push(...data.data);
                    this.loaded = this.data.length;
                } catch (error) {
                    console.log(error);
                }
                this.isFetching = false;
            }
        },
        
    },
    created() {
        document.addEventListener('scroll', this.onScroll)
        this.fetch();
    }, 
    beforeDestroy() {
        document.removeEventListener('scroll', this.onScroll)
    }
}
</script>

<style lang="scss" scoped>

</style>